// Số MẪU theo script board Mint-Training (app `mgr`: MX · PEOPLE · repDept · exRes). TODO(A): số thật khi có API đào tạo.

export type By = 'seat' | 'dept';

export const REQ_COLS: readonly { k: string; full: string }[] = [
  { k: 'Gửi bill', full: 'Gửi bill qua hệ thống (SOP-CS-07)' },
  { k: 'Release B/L', full: 'Release B/L theo mức nợ' },
  { k: 'Báo giá Live', full: 'Báo giá Live: margin theo tuyến' },
  { k: 'An toàn lái xe', full: 'An toàn lái xe container đêm' },
  { k: 'Nhập chi phí', full: 'Nhập chi phí trong ngày trên HANA Ezy mobile' },
];

export interface MatrixRow { k: string; full: string; n: number; vals: readonly (number | null)[] }

export const MATRIX: Record<By, readonly MatrixRow[]> = {
  seat: [
    { k: 'CSD-CSO', full: 'CS · Dịch vụ khách hàng', n: 4, vals: [75, 40, null, null, null] },
    { k: 'CSD-BKG', full: 'Booking', n: 4, vals: [90, 55, null, null, null] },
    { k: 'SALE-SE', full: 'Nhân viên kinh doanh', n: 3, vals: [null, 60, 100, null, null] },
    { k: 'OPS-DOC', full: 'Chứng từ / Hải quan', n: 4, vals: [80, null, null, null, 50] },
    { k: 'OPS-FLD', full: 'Hiện trường', n: 3, vals: [null, null, null, null, 70] },
    { k: 'TRD-DRV', full: 'Tài xế', n: 8, vals: [null, null, null, 62, 45] },
    { k: 'TRD-DSP', full: 'Điều độ', n: 1, vals: [null, null, null, 100, null] },
    { k: 'ACC-CP', full: 'Kế toán chi phí', n: 2, vals: [null, 100, null, null, 88] },
  ],
  dept: [
    { k: 'Kinh doanh', full: 'Phòng kinh doanh', n: 6, vals: [null, 72, 100, null, null] },
    { k: 'CS · Booking', full: 'Dịch vụ khách hàng & Booking', n: 8, vals: [82, 48, null, null, null] },
    { k: 'Chứng từ / HQ', full: 'Chứng từ & Hải quan', n: 4, vals: [80, null, null, null, 50] },
    { k: 'Vận tải', full: 'Vận tải', n: 12, vals: [null, null, null, 66, 52] },
    { k: 'Kế toán', full: 'Kế toán', n: 4, vals: [null, 100, null, null, 88] },
    { k: 'HC–NS', full: 'Hành chính nhân sự', n: 2, vals: [100, null, null, null, null] },
  ],
};

export const ONBOARD = [
  { k: 'NGỌC THẢO', p: 64, s: 'CS · tuần 2/4' },
  { k: 'QUANG', p: 30, s: 'Tài xế · tuần 1/2' },
  { k: 'BẢO NGÂN', p: 85, s: 'Kế toán · tuần 3/4' },
] as const;

export const DEPT_ON_TIME: readonly { k: string; w: number }[] = [
  { k: 'Kinh doanh', w: 84 }, { k: 'CS · Booking', w: 91 }, { k: 'Chứng từ / HQ', w: 88 },
  { k: 'Vận tải', w: 72 }, { k: 'Kế toán', w: 95 }, { k: 'HC–NS', w: 100 },
];

export interface Person { ab: string; k: string; seat: string; done: string; late: number; score: number; tries: number }
export const PEOPLE: readonly Person[] = [
  { ab: 'DV', k: 'DAVID', seat: 'SALE-MGR', done: '6/7', late: 1, score: 86, tries: 2 },
  { ab: 'MA', k: 'MAITTN', seat: 'CSD-CSO', done: '8/8', late: 0, score: 100, tries: 1 },
  { ab: 'PH', k: 'PhuongHT', seat: 'CSD-BKG', done: '7/8', late: 0, score: 94, tries: 1 },
  { ab: 'TN', k: 'TUANNT', seat: 'SALE-SE', done: '4/6', late: 2, score: 67, tries: 3 },
  { ab: 'TH', k: 'ThaoTN', seat: 'TRD-DRV', done: '1/3', late: 1, score: 48, tries: 2 },
  { ab: 'CG', k: 'CongNV', seat: 'TRD-DRV', done: '3/3', late: 0, score: 100, tries: 1 },
  { ab: 'TA', k: 'THANHTTK', seat: 'TRD-DSP', done: '5/6', late: 1, score: 83, tries: 2 },
  { ab: 'HN', k: 'HANHLTM', seat: 'ACC-CP', done: '6/6', late: 0, score: 100, tries: 1 },
];

export const EXAM_RESULTS = [
  { k: 'Gửi bill qua hệ thống', full: 'SOP-CS-07 · 10 câu', pass: 78, avg: 82 },
  { k: 'Release B/L theo mức nợ', full: 'SOP · Tài chính · 8 câu', pass: 61, avg: 74 },
  { k: 'Báo giá Live', full: 'Hướng dẫn · 8 câu', pass: 92, avg: 88 },
  { k: 'An toàn lái xe container đêm', full: 'Video · 6 câu', pass: 70, avg: 79 },
  { k: 'Tư vấn HS & form C/O', full: 'Hướng dẫn · 6 câu', pass: 95, avg: 91 },
] as const;

export type Level = 'done' | 'mid' | 'low';
export const levelOf = (v: number): Level => (v >= 90 ? 'done' : v >= 60 ? 'mid' : 'low');
export const passLevel = (v: number): Level => (v >= 90 ? 'done' : v >= 70 ? 'mid' : 'low');
export const scoreTone = (v: number): 'err' | 'warn' | 'ok' => (v < 70 ? 'err' : v < 90 ? 'warn' : 'ok');
export const avgTone = (v: number): 'err' | 'warn' | 'ok' => (v < 70 ? 'err' : v < 80 ? 'warn' : 'ok');
export const filterPeople = (q: string): Person[] => {
  const n = q.trim().toLowerCase();
  return PEOPLE.filter((p) => !n || p.k.toLowerCase().includes(n));
};
